module.exports = __webpack_public_path__ + "img/info.5a2a8b72.png";